import { Card, Col, Row, Typography } from "antd";
import React, { useState } from "react";
import AllTransactionPage from "./transaction/all_transaction";
import DepositTransaction from "./transaction/deposit_transaction";
import WithdrawTransaction from "./transaction/withdraw_transaction";
import { WalletBg } from "../../lib/svg_help";

const { Text } = Typography;
export default function WalletPage({ colors }) {
  const [activeTab, setActiveTab] = useState("all");

  const iconCards = [
    { icon: "assets/deposit.png", label: "Deposit", alt: "Deposit" },
    { icon: "assets/withdraw.png", label: "Withdraw", alt: "Withdraw" },
    { icon: "assets/TandC.png", label: "T & C", alt: "t&c" },
    { icon: "assets/exchange.png", label: "Exchange", alt: "Exchange" },
  ];

  const tabs = [
    { key: "all", label: "All" },
    { key: "deposit", label: "Deposit" },
    { key: "withdraw", label: "Withdraw" },
  ];

  const components = {
    all: AllTransactionPage,
    deposit: DepositTransaction,
    withdraw: WithdrawTransaction,
  };

  const ActiveComponent = components[activeTab];

  return (
    <>
    <Row justify="center">
      <Col style={{width:"100%"}}>
        <div
          style={{
            padding: "2px",
            background: "linear-gradient(to right, #9747ff, #77d770)",
            borderRadius: "20px",
            position: "relative",
          }}
        >
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
            borderRadius: "18px",
            overflow: "hidden"
          }}>
            <WalletBg 
              colors={colors} 
              style={{ 
                width: "100%", 
                height: "100%",
                objectFit: "cover"
              }} 
            />
          </div>
          
          <Card
            styles={{ body: { padding: 0, margin: 0 } }}
            style={{
              border: "none",
              borderRadius: "18px",
              padding: "20px 60px",
              position: "relative",
             
            }}
          >
            <Row justify="end">
              <Col style={{ position: "relative", zIndex: 1 }}>Promo Wallet</Col>
            </Row>
            <Row style={{ marginTop: "30px", position: "relative", zIndex: 1 }}>
              <Col span={24}>
                <Row>
                  <Text>Main Wallet</Text>
                </Row>
                <Row>
                  <Text strong style={{ fontSize: "20px" }}>
                    100,000 MMK
                  </Text>
                </Row>
              </Col>
            </Row>

            <Row style={{ marginTop: "60px", position: "relative", zIndex: 1 }}>
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Col>
                    <Text>Your Name</Text>
                  </Col>
                  <Col>
                    <Text>09547374737</Text>
                  </Col>
                  <Col>
                    <Text>xxxxxx678</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </div>

        <Row justify="center" style={{ margin: "16px 0", gap: "14px" }}>
          {iconCards.map((card, index) => (
            <Col
              key={index}
              style={{
                borderRadius: "20px",
                border: `1px solid ${colors.primary}`,
                padding: "6px 10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100px",
                height: "70px",
                backgroundColor: colors.background,
              }}
            >
              <img
                src={card.icon}
                style={{
                  padding: "10px 0 13px 0",
                }}
                alt={card.alt}
              />
              <Text>{card.label}</Text>
            </Col>
          ))}
        </Row>

        <Row justify="center" style={{ gap: "60px", padding: "16px 0px" }}>
          {tabs.map((tab) => (
            <Col
              key={tab.key}
              style={{ position: "relative", display: "inline-block" }}
            >
              <Text
                style={{
                  cursor: "pointer",
                }}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </Text>
              <span
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  bottom: -6,
                  height: "3px",
                  background: `linear-gradient(to right, ${colors.primary}, transparent)`,
                  transition: "all 0.3s",
                  width: activeTab === tab.key ? "80px" : "0",
                }}
              ></span>
            </Col>
          ))}
        </Row>

      
      </Col>
      <ActiveComponent colors={colors} />
    </Row>
   </>
  );
}